import { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';

import Textarea from '../../components/Textarea/Textarea';
import { Actions, Config, SimpleContainer, SimpleItem } from './styles';
import Button from '../../components/Button/Button';
import messages from './messages';
import Icon from '../../components/Icon';

interface ImageProps {
  url: string;
  width: number;
  height: number;
}

interface IComponentState {
  images: ImageProps[];
  textAreaValue: string;
}

class ImagePrint extends Component<any, IComponentState> {
  state = {
    images: [] as ImageProps[],
    textAreaValue: '',
  };
  readImages = () => {
    const { textAreaValue } = this.state;
    const urls = textAreaValue.split(/[\n]+/);
    const images = urls
      .map((u: string) => {
        if (u.includes('.pdf')) {
          // window.open(u, '_blank');
          return { url: null as any, width: 0, height: 0 };
        }
        return { url: u, width: 2, height: 2 };
      })
      .filter((it) => {
        return it.url !== null;
      });
    this.setState({ images });
  };

  private maxWidth = 6;
  makeTaller = (index: number) => () => {
    const { images } = this.state;
    const newImages = cloneDeep(images);
    newImages[index].height = Math.min(
      this.maxWidth,
      newImages[index].height + 1
    );
    this.setState({ images: newImages });
  };
  private maxHeight = 6;
  makeWider = (index: number) => () => {
    const { images } = this.state;
    const newImages = cloneDeep(images);
    newImages[index].width = Math.min(this.maxHeight, images[index].width + 1);
    this.setState({ images: newImages });
  };
  makeShorter = (index: number) => () => {
    const { images } = this.state;
    const newImages = cloneDeep(images);
    newImages[index].width = Math.max(1, images[index].width - 1);
    this.setState({ images: newImages });
  };
  makeSmaller = (index: number) => () => {
    const { images } = this.state;
    const newImages = cloneDeep(images);
    newImages[index].height = Math.max(1, images[index].height - 1);
    this.setState({ images: newImages });
  };
  goUp = (index: number) => () => {
    if (index === 0) return;
    const { images } = this.state;
    const newImages = cloneDeep(images);
    const temp = newImages[index - 1];
    newImages[index - 1] = newImages[index];
    newImages[index] = temp;
    this.setState({ images: newImages });
  };
  goDown = (index: number) => () => {
    const { images } = this.state;
    if (index >= images.length - 1) return;
    const newImages = cloneDeep(images);
    const temp = newImages[index];
    newImages[index] = newImages[index + 1];
    newImages[index + 1] = temp;
    this.setState({ images: newImages });
  };
  delete = (index: number) => () => {
    const { images } = this.state;
    const newImages = cloneDeep(images);
    newImages.splice(index, 1);
    this.setState({ images: newImages });
  };
  imageLoaded = (index: number) => (image: any) => {
    const { images } = this.state;
    const newImages = cloneDeep(images);
    let width = image.target.naturalWidth;
    let height = image.target.naturalHeight;
    if (width / height > 2) {
      width = Math.floor((width / height) * 2);
      height = 2;
    } else if (height / width > 2) {
      height = Math.floor((height / width) * 2);
      width = 2;
    } else {
      width = 2;
      height = 2;
    }
    newImages[index].width = Math.min(this.maxWidth, width);
    newImages[index].height = Math.min(this.maxHeight, height);
    this.setState({ images: newImages });
  };
  render() {
    const { textAreaValue, images } = this.state;
    return (
      <div>
        <Config>
          <Textarea
            placeholder={messages.hint}
            id="imageUrls"
            value={textAreaValue}
            onChange={(e) => {
              this.setState({ textAreaValue: e.target.value });
            }}
          />
          <Button onClick={this.readImages}>{messages.show}</Button>
        </Config>
        <SimpleContainer>
          {images.map((image: ImageProps, index) => {
            return (
              <SimpleItem
                key={index.toString()}
                id={index.toString()}
                style={{
                  gridColumnEnd: `span ${image.width || 1}`,
                  gridRowEnd: `span ${image.height || 1}`,
                }}
              >
                <img
                  src={image.url}
                  alt={''}
                  onLoad={this.imageLoaded(index)}
                />
                {
                  <Actions>
                    {/*<Button onClick={this.makeWider(index)}>
                    <Icon type="arrow-left" />
                  </Button>
                  <Button onClick={this.makeShorter(index)}>
                    <Icon type="arrow-right" />
                  </Button>
                  <Button onClick={this.makeTaller(index)}>
                    <Icon type="arrow-down" />
                  </Button>
                  <Button onClick={this.makeSmaller(index)}>
                    <Icon type="arrow-up" />
                  </Button>
                  <Button onClick={this.goUp(index)}>
                    <Icon type="arrow-up-circle" />
                  </Button>
                  <Button onClick={this.goDown(index)}>
                    <Icon type="arrow-down-circle" />
                  </Button>*/}
                    <Button onClick={this.delete(index)}>
                      <Icon type="delete" />
                    </Button>
                  </Actions>
                }
              </SimpleItem>
            );
          })}
        </SimpleContainer>
      </div>
    );
  }
}
export default ImagePrint;
